import { render } from "./ShekhList.vue?vue&type=template&id=2423194a"
import script from "./ShekhList.vue?vue&type=script&lang=js"
export * from "./ShekhList.vue?vue&type=script&lang=js"
script.render = render

export default script